import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-neutral-950 text-white pt-20 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="md:flex md:items-start md:justify-between gap-12">
          <div>
            <div className="flex items-end gap-4">
              <span className="relative inline-flex w-16 h-16 md:w-24 md:h-24 items-center justify-center rounded-[28%] bg-[#E8734A] shrink-0">
                <span className="font-heading font-bold text-white text-3xl md:text-5xl italic">5</span>
                <span className="absolute -top-2 -right-1 text-white text-lg md:text-2xl leading-none">✦</span>
              </span>
              <p className="font-heading font-bold text-6xl md:text-8xl tracking-tighter">5ads.ai</p>
            </div>
            <p className="text-neutral-400 mt-4 max-w-sm text-sm leading-relaxed">
              A family of AI-powered ad managers. Your ads, on autopilot — with you in control.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-12 mt-12 md:mt-2">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">Apps</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li>
                  <a
                    href="https://social.5ads.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-link-social"
                    className="text-neutral-300 hover:text-white inline-flex items-center gap-1 transition-colors"
                  >
                    social.5ads.ai <ArrowUpRight size={13} />
                  </a>
                </li>
                <li>
                  <span className="text-neutral-500" data-testid="footer-link-search">
                    search.5ads.ai <span className="font-mono text-[10px] uppercase tracking-wider text-[#FF6B2C] ml-1">soon</span>
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">Site</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li><a href="/#apps" className="text-neutral-300 hover:text-white transition-colors">Apps</a></li>
                <li><a href="/#how" className="text-neutral-300 hover:text-white transition-colors">How it works</a></li>
                <li><a href="/#features" className="text-neutral-300 hover:text-white transition-colors">Features</a></li>
                <li><a href="/#contact" className="text-neutral-300 hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">Legal</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li><a href="/privacy" data-testid="footer-link-privacy" className="text-neutral-300 hover:text-white transition-colors">Privacy Policy</a></li>
                <li><a href="/terms" data-testid="footer-link-terms" className="text-neutral-300 hover:text-white transition-colors">Terms of Service</a></li>
                <li><a href="/privacy#data-deletion" data-testid="footer-link-data-deletion" className="text-neutral-300 hover:text-white transition-colors">Data deletion</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-neutral-800 mt-16 pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-neutral-500">© {new Date().getFullYear()} 5ads.ai — All rights reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">Your ads. On autopilot.</p>
        </div>
      </div>
    </footer>
  );
}
